import axios from "axios";

const apiUrl = "https://modus-provider.azurewebsites.net";

export const getDataAPI = async (url) => {
  return axios.get(`${apiUrl + url}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// post
export const postDataAPI = async (url, post) => {
  return axios.post(`${apiUrl + url}`, post, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const postDataAPIWithToken = async (url, post) => {
  const TOKEN= `Bearer ${sessionStorage.getItem("loginToken")}`
  return axios.post(`${apiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

